import React from 'react';
import ProgressChecklist_LEGACY from '@/components/ProgressChecklist_LEGACY';
import { useDataPresentationParam } from '@/hooks';

export const ProgressChecklist = () => {
  const inEditQueryView = !useDataPresentationParam();

  return <ProgressChecklist_LEGACY sidebarOpen={inEditQueryView} />;
};
